import { useLanguageContext } from "../../../../context/LanguageContext";
import FieldConditionPage from "../../../../pages/fields/field/condition/FieldConditionPage";
import { useFieldEditRouteValidator } from "../../../validators/fields/FieldEditRouteValidator";
import { RouteConfig } from "../../RouteConfig";
import useFieldEditRouteConfig from "../FieldEditRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useFieldConditionEditRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/fields/:field/conditions/:field_condition/edit")
    .setLabel(
      translate("eva.main.entities.states.edit", [
        {
          key: "entities",
          value: translate("eva.main.entities.field_condition"),
        },
      ])
    )
    .setValidator(useFieldEditRouteValidator())
    .setPage(<FieldConditionPage />)
    .setParent(useFieldEditRouteConfig());
}

export default useFieldConditionEditRouteConfig;
